import * as React from 'react'
import PropTypes from 'prop-types'
import { MediaContentContainer, VideoContainer, ImageContainer, StyledImage } from './styles'

export function HeroMedia({ imageUrl, imageAlt, isVideo, videoUrl }) {
  const optimizedHeroBkgUrl = `${imageUrl}?quality=100&format=webp`

  return (
    <MediaContentContainer>
      {isVideo && (
        <VideoContainer playsInline autoPlay muted loop controls={false}>
          <source src={videoUrl} type="video/mp4" />
          <div>Video</div>
        </VideoContainer>
      )}
      {!isVideo && (
        <ImageContainer>
          <StyledImage src={optimizedHeroBkgUrl} alt={imageAlt} />
        </ImageContainer>
      )}
    </MediaContentContainer>
  )
}

HeroMedia.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  isVideo: PropTypes.bool,
  videoUrl: PropTypes.string,
}
